import { isPlatformBrowser } from '@angular/common';
import {
  Component,
  Inject,
  OnInit,
  PLATFORM_ID,
  ViewEncapsulation,
} from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { SwiperOptions } from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper';
import SwiperCore from 'swiper';

SwiperCore.use([Autoplay, Navigation, Pagination]);

export interface Benefits {
  img: string;
  name: string;
  header: string;
  text: string;
}

@Component({
  selector: 'app-benefits-slider',
  templateUrl: './benefits-slider.component.html',
  styleUrls: ['./benefits-slider.component.scss'],
  encapsulation: ViewEncapsulation.None,
  // Swiper rewrites slide DOM; hydrating prerendered markup throws
  // TypeError: Cannot read properties of null (reading 'hasAttribute').
  host: { ngSkipHydration: 'true' },
})
export class BenefitsSliderComponent implements OnInit {
  benefits: Benefits[];
  index = 0;
  /** Mount Swiper only in the browser (empty slot in SSG HTML). */
  showSwiper = false;

  swiperConfig: SwiperOptions = {
    observer: true,
    direction: 'horizontal',
    threshold: 40,
    spaceBetween: 40,
    slidesPerView: 1,
    preloadImages: false,
    watchSlidesProgress: true,
    breakpoints: {
      500: { slidesPerView: 2 },
      768: { slidesPerView: 3 },
      1200: { slidesPerView: 5 },
    },
    mousewheel: false,
    pagination: { clickable: true },
    autoplay: { delay: 3000, disableOnInteraction: false },
    navigation: true,
  };

  constructor(
    private transloco: TranslocoService,
    @Inject(PLATFORM_ID) private platformId: object,
  ) {
    this.benefits = [
      {
        img: '1',
        name: this.transloco.translate('home.benefits.slider.slide.1'),
        header: this.transloco.translate('home.benefits.slider.header.1'),
        text: this.transloco.translate('home.benefits.slider.text.1'),
      },
      {
        img: '2',
        name: this.transloco.translate('home.benefits.slider.slide.2'),
        header: this.transloco.translate('home.benefits.slider.header.2'),
        text: this.transloco.translate('home.benefits.slider.text.2'),
      },
      {
        img: '3',
        name: this.transloco.translate('home.benefits.slider.slide.3'),
        header: this.transloco.translate('home.benefits.slider.header.3'),
        text: this.transloco.translate('home.benefits.slider.text.3'),
      },
      {
        img: '4',
        name: this.transloco.translate('home.benefits.slider.slide.4'),
        header: this.transloco.translate('home.benefits.slider.header.4'),
        text: this.transloco.translate('home.benefits.slider.text.4'),
      },
      {
        img: '5',
        name: this.transloco.translate('home.benefits.slider.slide.5'),
        header: this.transloco.translate('home.benefits.slider.header.5'),
        text: this.transloco.translate('home.benefits.slider.text.5'),
      },
      {
        img: '6',
        name: this.transloco.translate('home.benefits.slider.slide.6'),
        header: this.transloco.translate('home.benefits.slider.header.6'),
        text: this.transloco.translate('home.benefits.slider.text.6'),
      },
      {
        img: '7',
        name: this.transloco.translate('home.benefits.slider.slide.7'),
        header: this.transloco.translate('home.benefits.slider.header.7'),
        text: this.transloco.translate('home.benefits.slider.text.7'),
      },
      {
        img: '8',
        name: this.transloco.translate('home.benefits.slider.slide.8'),
        header: this.transloco.translate('home.benefits.slider.header.8'),
        text: this.transloco.translate('home.benefits.slider.text.8'),
      },
    ];
  }

  ngOnInit(): void {
    this.showSwiper = isPlatformBrowser(this.platformId);
  }
}
